import { render, staticRenderFns } from "./participateRecord.vue?vue&type=template&id=92197c22&scoped=true"
import script from "./participateRecord.vue?vue&type=script&lang=js"
export * from "./participateRecord.vue?vue&type=script&lang=js"
import style0 from "./participateRecord.vue?vue&type=style&index=0&id=92197c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92197c22",
  null
  
)

export default component.exports